const AnchorHashIds = {
    VerifyNonprofit: 'verify-your-nonprofit',
    ManageGivebutterPlusPlan: 'manage-givebutter-plus-plan',
    BillingViewGivebutterPlusPlan: 'billing-view-givebutter-plus-plan',
};

export { AnchorHashIds };
